<div
  *ngIf="hasLicense && licenseInfo; else infoBlock"
  class="sys-license-wrapper"
>
  <div class="sys-info-row">
    <span class="label">{{ 'Customer Name' | translate }}:</span>
    <span class="value">{{ licenseInfo.customer_name }}</span>
  </div>
  <div class="sys-info-row">
    <span class="label">{{ 'Features' | translate }}:</span>
    <span class="value">{{ licenseInfo.features.join(', ') }}</span>
  </div>
  <div class="sys-info-row">
    <span class="label">{{ 'Contract Type' | translate }}:</span>
    <span class="value">{{ licenseInfo.contract_type }}</span>
  </div>
  <div class="sys-info-row">
    <span class="label">{{ 'Expiration Date' | translate }}:</span>
    <span class="value"
      >{{ licenseInfo.expiration_date }}
      <span *ngIf="licenseInfo.daysLeftinContract > 0">
        ({{ 'expires in {n, plural, one {# day} other {# days} }' | translate: { n: licenseInfo.daysLeftinContract } }})
      </span>
      <span *ngIf="licenseInfo.daysLeftinContract === 0">
        ( {{ 'EXPIRES TODAY' | translate }} )
      </span>
      <span *ngIf="licenseInfo.daysLeftinContract < 0">
        ( {{ 'EXPIRED' | translate }} )
      </span>
    </span>
  </div>
  <div class="sys-info-row">
    <span class="label">{{ 'Model' | translate }}:</span>
    <span class="value">{{ systemInfo.model }}</span>
  </div>
  <div *ngIf="systemInfo.system_serial" class="sys-info-row">
    <span class="label">{{ 'System Serial' | translate }}:</span>
    <span class="value">{{ systemInfo.system_serial }}</span>
  </div>
  <div *ngIf="licenseInfo?.system_serial || licenseInfo?.system_serial_ha" class="sys-info-row">
    <span class="label">{{ 'Licensed Serials' | translate }}:</span>
    <span class="value">
      <span *ngIf="licenseInfo?.system_serial">{{ licenseInfo.system_serial }}</span>
      <span *ngIf="licenseInfo?.system_serial && licenseInfo?.system_serial_ha"> / </span>
      <span *ngIf="licenseInfo?.system_serial_ha">{{ licenseInfo.system_serial_ha }}</span>
    </span>
  </div>
  <div *ngIf="licenseInfo.add_hardware" class="sys-info-row">
    <span class="label">{{ 'Additional Hardware' | translate }}:</span>
    <span class="value">{{ licenseInfo.add_hardware }}</span>
  </div>
</div>

<ng-template #infoBlock>
  <div class="sys-info-wrapper">
    <div class="sys-info-row">
      <span class="label">{{ 'OS Version' | translate }}:</span>
      <span class="value">{{ systemInfo.version }}</span>
    </div>
    <div class="sys-info-row">
      <span class="label">{{ 'Product' | translate }}:</span>
      <span class="value">{{ systemInfo.system_product }}</span>
    </div>
    <div *ngIf="systemInfo.model" class="sys-info-row">
      <span class="label">{{ 'Model' | translate }}:</span>
      <span class="value">{{ systemInfo.model }}</span>
    </div>
    <div *ngIf="systemInfo.memory" class="sys-info-row">
      <span class="label">{{ 'Memory' | translate }}:</span>
      <span class="value">{{ systemInfo.memory }}</span>
    </div>
    <div *ngIf="systemInfo.system_serial" class="fn-sys-info-row">
      <span class="label">{{ 'System Serial' | translate }}:</span>
      <span class="value">{{ systemInfo.system_serial }}</span>
    </div>
  </div>
</ng-template>
